import { createSlice } from '@reduxjs/toolkit'
import reconcileRedrivingTasks from '../utils/reconcileRedrivingTasks'

export const REDRIVE_RECONCILE_WINDOW_MS = 90000

export const executionTasksSlice = createSlice({
  name: "executionTask",
  initialState: {
    executionTask: {},
    executionTaskFilters: [],
    filters: { order: {fleet_execution_task_id: "growing"} },
    dataTerminate: null,
    dataRedrive: null
  },
  reducers: {
    addFleetExecutionTask: (state, action) => {
      state.executionTask = {...state.executionTask, ...action.payload}
      state.executionTaskFilters = action.payload
    },
    addFilter: (state, action) => {
      const filters = action.payload
      state.filters = filters
    },
    setViewTerminate: (state, action) => {
      state.viewCancelPopUp = action.payload.view
      state.dataTerminate = action.payload.data
    },
    setViewRedrive: (state, action) => {
      state.viewRedrivePopUp = action.payload.view
      state.dataRedrive = action.payload.data
    },
    invalidateFleetExecutionTask: (state, action) => {
      const { [action.payload]: _removed, ...rest } = state.executionTask
      state.executionTask = rest
    },
    markTaskRedriving: (state, action) => {
      const { fleet_execution_id, fleet_execution_task_id } = action.payload
      const fleet = state.executionTask[fleet_execution_id]
      if (!fleet || !fleet.executionTask) return
      fleet.executionTask = fleet.executionTask.map((task) =>
        task.fleet_execution_task_id === fleet_execution_task_id
          ? { ...task, status: 'Redriving', redrivable: false, redriving_since: Date.now() }
          : task
      )
      fleet.time_added = Date.now()
    },
    reconcileFleetExecutionTasks: (state, action) => {
      const { fleet_execution_id, tasks } = action.payload
      const fleet = state.executionTask[fleet_execution_id]
      if (!fleet) return
      fleet.executionTask = reconcileRedrivingTasks(fleet.executionTask || [], tasks, Date.now(), REDRIVE_RECONCILE_WINDOW_MS)
      fleet.time_added = Date.now()
    }
  },
});

export const { addFleetExecutionTask, addFilter, setViewTerminate, setViewRedrive, invalidateFleetExecutionTask, markTaskRedriving, reconcileFleetExecutionTasks } = executionTasksSlice.actions
export default executionTasksSlice.reducer
